<template>
  <v-autocomplete :disabled="dis" :items="options" @input="onChange" item-text="Label" item-value="Value" v-model="selected">
    <template slot="label">
      <span v-html="label" />
    </template>
  </v-autocomplete> 
</template>

<script>
import dataSvc from "@/services/dataService";
export default {
  props: ["value", "menu", "label","dis" ],
  data() {
    return {
      selected: null,
      options: []
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.selected);
    }
  },
  created() {
    this.selected = this.value;
     
    dataSvc.loadDD(this.menu).then(res => {
      this.options = res;
    });
  },

  watch: {
    value(n) {
      this.selected = n;
    }
  }
};
</script>

<style></style>
